import HexController from 'controllers/hex_controller'
import { findIndex } from 'underscore'

function encodeHTML(value) {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export default class extends HexController {
  static targets = ['testCaseSelector', 'strengthSelector'];

  static values = {
    fetchCasesUrl: String,
    fetchCombinationsUrl: String,
    combinationsUrl: String,
    combinationValuePosition: Number,
    combinationIdPosition: Number,
    parameters: Array
  }

  _lastTestCase = null;

  connect() {
    this.loadTestCase();
  }

  updateTestCasePreview() {
    this.element.querySelectorAll('.manual-script-step-action-preview, .manual-script-step-data-preview, .manual-script-step-expected-result-preview').forEach(el => {
      const textarea = el.parentElement.querySelector('textarea');
      el.dataset.value = textarea.value;
    });
    this.updateTestCase(this._lastTestCase);
  }

  updateTestCase(testCase) {
    this._lastTestCase = testCase;
    const caseValues = testCase?.caseValues;
    // Update the action, data and expected result previews
    this.element.querySelectorAll('.manual-script-step-action-preview, .manual-script-step-data-preview, .manual-script-step-expected-result-preview').forEach(el => {
      let value = el.dataset.value || '';
      if (caseValues) {
        caseValues.map((testCaseValue, idx) => {
          const val = testCaseValue[this.combinationValuePositionValue];
          const param = this.parametersValue[idx];
          const escapedParamName = escapeRegExp(param.name);
          value = value.replace(new RegExp(`<${escapedParamName}>`, 'g'), `_OBOLD_${val}_CBOLD_`);
        });
        // Encode HTML characters
        value = encodeHTML(value);
        value = value.replace(/_OBOLD_(.*?)_CBOLD_/g, '<b>$1</b>');
        el.innerHTML = value;
      } else {
        // If there are no case values, set the textContent to avoid interpreting variables as HTML
        el.textContent = value;
      }
    });
    // Update the conditions
    this.element.querySelectorAll('.manual-script-step-item.step-item-conditions').forEach(el => {
      let conditionsMatch = null;
      let conditionPreview = '';
      el.querySelectorAll('.manual-script-step-condition').forEach(conditionEl => {
        const conditionParamId = parseInt(conditionEl.querySelector('.manual-script-step-condition-parameter').value);
        if (conditionParamId) {
          conditionPreview += conditionPreview.length === 0 ? 'if ' : ' and ';
          const paramIndex = findIndex(this.parametersValue, p => p.id === conditionParamId);
          const param = this.parametersValue[paramIndex];
          const isToggle = conditionEl.querySelector('.manual-script-step-condition-is-toggle').value === 'true';
          const conditionValue = conditionEl.querySelector('.manual-script-step-condition-value').value;
          // Calculate the condition match
          let conditionMatch = null;
          if (caseValues) {
            const caseValue = caseValues[paramIndex];
            const caseValueId = caseValue[this.combinationIdPositionValue]
            // Get the value id from the param values
            const conditionValueId = Number(Object.keys(param.values).find(key => param.values[key] === conditionValue));
            // Check if the id is equal to the case value id
            const matchingValueId = conditionValueId === caseValueId;
            conditionMatch = isToggle ? matchingValueId : !matchingValueId;
          }
          // Compose the condition preview string
          conditionPreview += `<span class='${conditionMatch ? 'condition-match' : 'condition-no-match'}'><b>${encodeHTML(param.name)}</b> ${isToggle ? 'is' : 'is not'} <b>${encodeHTML(conditionValue)}</b></span>`;
          // Calculate the conditions match
          if (conditionsMatch === null) {
            conditionsMatch = conditionMatch;
          } else {
            conditionsMatch = conditionsMatch && conditionMatch;
          }
        }
      })
      el.querySelector('.manual-script-step-condition-preview').innerHTML = conditionPreview;
      const manualScriptStepGroupEl = el.closest('.manual-script-step-group');
      manualScriptStepGroupEl.classList.remove('step-match');
      manualScriptStepGroupEl.classList.remove('step-no-match');
      if (conditionsMatch === true) {
        manualScriptStepGroupEl.classList.add('step-match');
      } else if (conditionsMatch === false) {
        manualScriptStepGroupEl.classList.add('step-no-match');
      }
    });
  }

  loadTestCase() {
    if (this.hasTestCaseSelectorTarget && this.testCaseSelectorTarget.value.length > 0) {
      const testCaseNumber = parseInt(this.testCaseSelectorTarget.value);
      // Update the test case number on the server
      const url = new URL(this.fetchCasesUrlValue, window.location.origin);
      url.searchParams.set('testCase', testCaseNumber);
      fetch(url.href, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        }
      }).then(
        response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Failed to update selected test case');
        }
      ).then(data => {
        this.updateTestCase(data);
      }).catch(error => {
        console.error('Error updating selected test case:', error);
      });
    }
  }

  loadCombination(strength) {
    const url = new URL(this.fetchCombinationsUrlValue, window.location.origin);
    url.searchParams.set('strength', strength);
    fetch(url.href, {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      }
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Failed to load combinations');
    }).then(data => {
      const combinationSize = data.casesCount;
      // Replace the cases select options
      this.testCaseSelectorTarget.innerHTML = '';
      for (let i = 1; i <= combinationSize; i++) {
        const option = document.createElement('option');
        option.value = i;
        option.textContent = i;
        option.selected = i === 1;
        this.testCaseSelectorTarget.appendChild(option);
      }
      this.loadTestCase();
    }).catch(error => {
      console.error('Error loading combinations:', error);
    });
  }

  strengthChange(event) {
    const strength = parseInt(event?.target?.value, 10)
    if (!strength) {
      Turbo.visit(this.combinationsUrlValue)
    } else {
      this.loadCombination(strength)
    }
  }
}
